import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [entries, setEntries] = useState({});
  const [lang, setLang] = useState("en");
  const [availableLanguages, setAvailableLanguages] = useState(["en"]);
  const [serviceSlugs, setServiceSlugs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async (l = "en") => {
    setLoading(true);
    try {
      const { data } = await api.get(`/content?lang=${encodeURIComponent(l)}`);
      setEntries(data.entries || {});
      setLang(data.lang);
      setAvailableLanguages(data.available_languages || ["en"]);
      setServiceSlugs(data.service_slugs || []);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load("en");
  }, [load]);

  const t = useCallback(
    (key, fallback = "") => {
      const v = entries[key];
      return v === undefined || v === null ? fallback : v;
    },
    [entries]
  );

  return (
    <ContentContext.Provider
      value={{ t, entries, lang, availableLanguages, serviceSlugs, loading, reload: load }}
    >
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
